import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({name: 'errorKey'})
export class ErrorKeyPipe implements PipeTransform {

  transform(formControl: AbstractControl): string {
    const errorKey = formControl?.errors && formControl?.errors?.message ?
                     formControl.errors.message : 'notValid';
    return `errors.${errorKey}`;
  }
}
